import { useEffect, useRef } from 'react';

import { setupDifferenceColorObserver } from './utils';

const OBSERVER_SETUP_DELAY_MS = 100;

export const useDifferenceColorObserver = (enabled: boolean, widgetType?: number) => {
  const observerCleanupRef = useRef<(() => void) | undefined>(undefined);
  const plotRef = useRef<any>(null);

  const onChartReady = (plot: any) => {
    plotRef.current = plot;

    if (observerCleanupRef.current) {
      observerCleanupRef.current();
      observerCleanupRef.current = undefined;
    }

    if (!enabled) {
      return;
    }

    setTimeout(() => {
      observerCleanupRef.current = setupDifferenceColorObserver(plot, widgetType);
    }, OBSERVER_SETUP_DELAY_MS);
  };

  useEffect(() => {
    if (!enabled && observerCleanupRef.current) {
      observerCleanupRef.current();
      observerCleanupRef.current = undefined;
    }

    if (enabled && plotRef.current && !observerCleanupRef.current) {
      observerCleanupRef.current = setupDifferenceColorObserver(plotRef.current, widgetType);
    }
  }, [enabled, widgetType]);

  useEffect(() => {
    return () => {
      if (observerCleanupRef.current) {
        observerCleanupRef.current();
      }
    };
  }, []);

  return { onChartReady };
};
